import React, { createContext } from 'react'
import UserServices from './Services/Consumers/UserServices'
import { useKeycloak } from '@react-keycloak/web'

const OTPCaptchaContext = createContext({})

const OTPCaptchaProvider = ({ children }) => {
  const { keycloak } = useKeycloak()
  const [captchaData, setCaptchaData] = React.useState({})
  const [captchaDataLoading, setCaptchaDataLoading] = React.useState(false)
  const [captchaDataFailure, setCaptchaDataFailure] = React.useState(false)
  const generateCaptcha = () => {
    if (!!keycloak?.authenticated) {
      setCaptchaDataFailure(false)
      setCaptchaDataLoading(true)
      UserServices.generateCaptcha({ headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` } }, captchaDataLoading, setCaptchaDataFailure).then((result) => {
        if ((!!result.response && result.response.status !== 200) || !result) {
          setCaptchaDataFailure(true)
        } else {
          if (!!result && !!result.data) {
            setCaptchaData(result.data)
          }
        }
      }).then(() => {
        setCaptchaDataLoading(false)
      })
    }
  }

  return (
    <OTPCaptchaContext.Provider value={{
      generateCaptcha,
      captchaData,
      captchaDataLoading,
      captchaDataFailure
    }}>
      {children}
    </OTPCaptchaContext.Provider>
  )
}
export { OTPCaptchaProvider, OTPCaptchaContext }
